export const FETCH_TICKETS_START = 'FETCH_TICEKTS_START';
export const FETCH_TICEKTS_SUCCESS = 'FETCH_TICEKTS_SUCCESS';
export const FETCH_TICEKTS_FAILURE = 'FETCH_TICEKTS_FAILURE';

export const FETCH_TICEKTS_RESET = 'FETCH_TICEKTS_RESET';
